import {
  API_CREATED,
  API_CREATE_FAILED,
  API_READ,
  API_READ_FAILED,
  API_UPDATED,
  API_UPDATE_FAILED,
  API_DELETED,
  API_DELETE_FAILED,
} from '@keypr/redux-json-api/lib/constants';
import { get } from 'lodash';
import actions from '../actions';
import { showLoading, hideLoading } from '../reducers/preloader';

const refreshMiddleware = store => next => (action) => {
  const {
    api,
    refresh,
  } = store.getState();
  const showLoader = !get(action, 'payload.options.noLoader');

  if (action.type.indexOf('API_WILL_') !== -1 && showLoader) {
    let blocking = false;
    if (['API_WILL_UPDATE', 'API_WILL_CREATE'].indexOf(action.type) !== -1) {
      blocking = true;
    }
    store.dispatch(showLoading(blocking));
  }

  if (action.type.substring(0, 8) === '@@router') {
    store.dispatch(hideLoading());
  }

  // Handle new SR ticket labels
  if (api.isReading <= 1 && (action.type === API_READ)) {
    store.dispatch(actions.refreshNewSrAction());
  }

  if (api.isReading <= 1 && (action.type === API_READ || action.type === API_READ_FAILED)) {
    store.dispatch(hideLoading());
  }

  if (api.isCreating <= 1 && (action.type === API_CREATED || action.type === API_CREATE_FAILED)) {
    store.dispatch(hideLoading());
  }

  if (api.isDeleting <= 1 && (action.type === API_DELETED || action.type === API_DELETE_FAILED)) {
    store.dispatch(hideLoading());
  }

  if (api.isUpdating <= 1 && (action.type === API_UPDATED || action.type === API_UPDATE_FAILED)) {
    store.dispatch(hideLoading());
  }

  if (refresh.refreshing === true && api.isReading <= 1 && (action.type === API_READ || action.type === API_READ_FAILED)) {
    store.dispatch(hideLoading());
    store.dispatch(actions.refreshComplete());
  }

  return next(action);
};

export default refreshMiddleware;



// WEBPACK FOOTER //
// ./src/state/middleware/refresh.js